"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringTrim = void 0;
/**
 * Obcina początkowe i końcowe spacje w tekscie
 * @param text tekst do obcięcia
 */
function stringTrim(text) {
    return (text || '').trim();
}
exports.stringTrim = stringTrim;
//# sourceMappingURL=stringTrim.js.map